// extracted by mini-css-extract-plugin
export default {"container":"ResetPassword_container__LUY5X","inputContainer":"ResetPassword_inputContainer__g2H24","submitBTN":"ResetPassword_submitBTN__RX6Ps"};